import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { LEFT, RIGHT } from "../constants";
export const sideUnitKeys = {
    [LEFT]: "side-unit-left",
    [RIGHT]: "side-unit-right",
};
export const sideUnitConnectorKeys = {
    [LEFT]: "section-align-left",
    [RIGHT]: "section-align-right",
};
const selectPartKey = (entity) => {
    var _a;
    return (_a = entity.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.partKey;
};
export const selectChildEntityByPartKey = (entity, key) => HierarchyUtils.children(entity).find((child) => selectPartKey(child) === key);
export const detachEntityFromParent = (entity) => {
    HierarchyUtils.setParentMaintainTransform(entity, null);
};
export const attachEntityToParent = (entity) => {
    const parent = HierarchyUtils.parent(entity);
    HierarchyUtils.setParent(entity, parent);
};
